export { Span } from "../../../api/src/core/tracing/span.decorator";
